import type AudioPlayer from '../audioplayer';

let _audioPlayer: AudioPlayer | null = null;

export function initAudioPlayerPauseImplementation(audioPlayer: AudioPlayer) {
  _audioPlayer = audioPlayer;
}

export async function runAudioPlayerPauseImplementation() {
  if (!_audioPlayer) return;
  _audioPlayer.pause();
}
